"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const SearchPage_1 = __importDefault(require("../states/SearchPage"));
const translate_1 = require("../helper/translate");
class SelectedFiltersStore {
    constructor() {
        Object.defineProperty(this, "selectedFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "showSummary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "summaryFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "statisticsResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "benchmarks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "count", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        (0, mobx_1.makeAutoObservable)(this);
    }
    setBenchmarks(benchmarks) {
        this.benchmarks = benchmarks;
    }
    setCount(count) {
        this.count = count;
    }
    setStatisticsResult(statisticsResult) {
        this.statisticsResult = statisticsResult;
    }
    setFilters(filters) {
        const criteriaValue = SearchPage_1.default.getLevelValue("criteria");
        const option = SearchPage_1.default.columnList.criteria.find((option) => option.value === criteriaValue);
        let criteriaLabel = (option !== undefined) ? option.label : undefined;
        if (filters.hasOwnProperty('level1Value') || filters.hasOwnProperty('columnValue')) {
            let topBottomValue = filters.topBottomValue;
            let benchmarkValue = filters.benchmarkValue == (0, translate_1.translate)('None') ? undefined : filters.benchmarkValue;
            topBottomValue = topBottomValue.charAt(0).toUpperCase() + topBottomValue.slice(1);
            const transformedFilters = {
                level1: filters.level1Value || undefined,
                column: filters.columnValue || undefined,
                topBottom: topBottomValue || undefined,
                level2: filters.level2Value || undefined,
                level3: filters.level3Value || undefined,
                criteria: criteriaLabel || undefined,
                benchmarks: benchmarkValue,
                count: filters.count || undefined,
            };
            this.filters = transformedFilters;
        }
        else {
            this.filters = filters;
        }
    }
}
const selectedFiltersStore = new SelectedFiltersStore();
exports.default = selectedFiltersStore;
